/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Until_TipoffInputs */

const th_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก่อนเริ่มแข่ง`)
};

const en_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until tipoff`)
};

const ja_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ティップオフまで`)
};

const zh_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`距离开球`)
};

const es_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para el inicio`)
};

const pt_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até o início`)
};

const id_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menuju tip-off`)
};

const fr_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant le coup d’envoi`)
};

const tl_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanggang tip-off`)
};

const vi_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến giờ bóng lên rổ`)
};

const ko_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 시작까지`)
};

const de_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zum Anwurf`)
};

const ru_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До начала`)
};

const tr_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlama saatine`)
};

const it_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla palla a due`)
};

const pl_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do rozpoczęcia`)
};

const uk_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До початку`)
};

const hi_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू होने तक`)
};

const ar_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حتى بداية المباراة`)
};

const ms_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehingga permulaan`)
};

const bn_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরুর আগে`)
};

const zh_tw2_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`距離開賽`)
};

const zh_hk2_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`距離開賽`)
};

const ur_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آغاز تک`)
};

const fa_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تا آغاز بازی`)
};

const sw_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadi kuanza`)
};

const nl_until_tipoff = /** @type {(inputs: Until_TipoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot aanvang`)
};

/**
* | output |
* | --- |
* | "Until tipoff" |
*
* @param {Until_TipoffInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const until_tipoff = /** @type {((inputs?: Until_TipoffInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Until_TipoffInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_until_tipoff(inputs)
	if (locale === "ja") return ja_until_tipoff(inputs)
	if (locale === "zh") return zh_until_tipoff(inputs)
	if (locale === "es") return es_until_tipoff(inputs)
	if (locale === "pt") return pt_until_tipoff(inputs)
	if (locale === "id") return id_until_tipoff(inputs)
	if (locale === "fr") return fr_until_tipoff(inputs)
	if (locale === "tl") return tl_until_tipoff(inputs)
	if (locale === "vi") return vi_until_tipoff(inputs)
	if (locale === "ko") return ko_until_tipoff(inputs)
	if (locale === "de") return de_until_tipoff(inputs)
	if (locale === "ru") return ru_until_tipoff(inputs)
	if (locale === "tr") return tr_until_tipoff(inputs)
	if (locale === "it") return it_until_tipoff(inputs)
	if (locale === "pl") return pl_until_tipoff(inputs)
	if (locale === "uk") return uk_until_tipoff(inputs)
	if (locale === "hi") return hi_until_tipoff(inputs)
	if (locale === "ar") return ar_until_tipoff(inputs)
	if (locale === "ms") return ms_until_tipoff(inputs)
	if (locale === "bn") return bn_until_tipoff(inputs)
	if (locale === "zh-TW") return zh_tw2_until_tipoff(inputs)
	if (locale === "zh-HK") return zh_hk2_until_tipoff(inputs)
	if (locale === "ur") return ur_until_tipoff(inputs)
	if (locale === "fa") return fa_until_tipoff(inputs)
	if (locale === "sw") return sw_until_tipoff(inputs)
	if (locale === "nl") return nl_until_tipoff(inputs)
	return en_until_tipoff(inputs)
});